import * as React from "react";
import Header from "../header";
import Footer from "../footer";
import SplashScreen from "../SplashScreen";

let hasPlayedSplash = false;

export default function Layout({ children, layout = "default" }) {
  const [splashState, setSplashState] = React.useState(
    hasPlayedSplash ? "done" : "visible",
  );

  React.useEffect(() => {
    if (splashState === "done") return;
    const showTimer = setTimeout(() => setSplashState("exiting"), 1400);
    return () => clearTimeout(showTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (splashState !== "exiting") return;
    const exitTimer = setTimeout(() => {
      setSplashState("done");
      hasPlayedSplash = true;
    }, 1800);
    return () => clearTimeout(exitTimer);
  }, [splashState]);

  if (layout === "none") return <>{children}</>;

  return (
    <>
      {splashState !== "done" && (
        <SplashScreen isExiting={splashState === "exiting"} />
      )}
      <Header />
      <div>{children}</div>
      <Footer />
    </>
  );
}
